// src/components/DynamicReportInputs/CycleSelector.js
import React, { useState, useEffect } from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  FormHelperText,
  makeStyles,
} from "@material-ui/core";
import { dbGet } from "utils/DBFetchers"; // Asumo que usas tu utilidad estándar

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: 250,
    width: "100%",
  },
}));

const formatCycleLabel = (cycle) => {
  const str = String(cycle || "");
  if (str.length === 6) {
    return `${str.substring(0, 4)}-${str.substring(4, 6)}`;
  }
  return str;
};

export default function CycleSelector({ value, onChange, error = null, required = false }) {
  const classes = useStyles();
  const [cycles, setCycles] = useState([]);
  const [fetchError, setFetchError] = useState(null);

  useEffect(() => {
    let active = true;

    const fetchCycles = async () => {
      try {
        const data = await dbGet("traceability/cycles");
        
        if (active) {
          const list = Array.isArray(data) ? data : data.cycles || [];
          setCycles(list);
        }
      } catch (err) {
        if (active) {
          setFetchError("Error al cargar ciclos");
        }
      }
    };

    fetchCycles();

    return () => {
      active = false;
    };
  }, []);

  const handleChange = (event) => {
    onChange(event.target.value);
  };

  return (
    <FormControl 
      variant="outlined" 
      className={classes.formControl} 
      error={!!error || !!fetchError}
      required={required}
    >
      <InputLabel id="cycle-select-label">Ciclo</InputLabel>
      <Select
        labelId="cycle-select-label"
        id="cycle-select"
        value={value}
        onChange={handleChange}
        label="Ciclo"
      >
        <MenuItem value="">
          <em>Seleccione</em>
        </MenuItem>
        
        {cycles.map((cycle) => (
          <MenuItem key={cycle} value={cycle}>
            {formatCycleLabel(cycle)}
          </MenuItem>
        ))}
      </Select>
      
      {cycles.length === 0 && !fetchError && (
        <FormHelperText>Cargando opciones...</FormHelperText>
      )}
      {fetchError && <FormHelperText>{fetchError}</FormHelperText>}
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
}
